
import MessagesTable from '@/views/_messages/components/MessagesTable.vue';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'Messages',
	components: {
		MessagesTable
	},
	computed: {
		messageType: {
			get() {
				if (this.$store.state.messages.messageType) {
					return this.$store.state.messages.messageType;
				} else {
					return 'ALL';
				}
			},
			set(val) {
				this.$store.commit('messages/SET_MESSAGE_TYPE', val);
			}
		}
	},
	created() {
		this.$store.commit('messages/SET_MESSAGE_TYPE', 'IN');
		this.$store.commit('messages/SET_FILTER_RECIPIENT', null);
	}
});
